import { Link, useLocation } from 'react-router'
import { Boxes } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import { useSession } from '@/hooks/useSession'
import { homeFor, sectionOf, sectionsFor } from './nav'

// 레일은 **대분류만** 그린다. 사이드바가 그리는 것과 겹치지 않는다.
// 섹션을 누르면 그 섹션의 첫 상세 메뉴로 간다 — 빈 중간 화면을 만들지 않는다.
// 예외는 `대시보드`(와 로고): 검토할 것이 있으면 `검토 대기`, 없으면 `클러스터` 다 — 처리할 것이 없는데 빈 화면을 먼저 보이지 않는다.

export function Rail({ pending }: { pending: number }) {
  const { pathname } = useLocation()
  const here = sectionOf(pathname)
  const { role } = useSession()
  const sections = sectionsFor(role)
  const home = homeFor(role, pending)

  return (
    <aside className="flex h-full w-16 flex-none flex-col items-center gap-1 overflow-y-auto bg-rail py-3">
      <Link
        to={home}
        className="mb-3 flex size-10 items-center justify-center rounded-lg bg-white/12 text-white"
        aria-label="LCCS"
      >
        <Boxes className="size-5" />
      </Link>

      {sections.map((s) => {
        const first = s.items[0]!
        const on = s.id === here.id
        return (
          <Tooltip key={s.id}>
            <TooltipTrigger asChild>
              <Link
                to={s.id === 'home' ? home : first.to}
                aria-label={s.label}
                aria-current={on ? 'page' : undefined}
                className={cn(
                  'relative flex size-10 items-center justify-center rounded-lg transition-colors',
                  on
                    ? 'bg-rail-active text-rail-fg-active after:absolute after:-right-3 after:size-0 after:border-y-6 after:border-r-6 after:border-y-transparent after:border-r-surface'
                    : 'text-rail-fg hover:bg-rail-active/60 hover:text-rail-fg-active',
                )}
              >
                <s.icon className="size-5" />
              </Link>
            </TooltipTrigger>
            <TooltipContent side="right">{s.label}</TooltipContent>
          </Tooltip>
        )
      })}
    </aside>
  )
}
